module.exports = __webpack_public_path__ + "img/coupon-5.07211e4c.png";